import PropTypes from 'prop-types'
import React from 'react'

import {
  StyledContainer,
  StyledLoader,
  StyledText
} from './WidgetLoader.styles'

export const WidgetLoader = ({ children, loading, className }) => {
  if (!loading) return null
  return (
    <StyledContainer className={className}>
      <StyledText>{children}</StyledText>
      <StyledLoader
        color='#16a7cd'
        corners={1}
        direction={1}
        length={0}
        lines={6}
        loaded={!loading}
        loadedClassName='loadedContent'
        position='relative'
        radius={10}
        rotate={90}
        shadow={false}
        speed={1.4}
        width={10}
        scale={1.2}
        zIndex={200}
      />
    </StyledContainer>
  )
}

WidgetLoader.defaultProps = {
  loading: false
}

WidgetLoader.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool,
  className: PropTypes.string
}
